import { useSelector } from "react-redux";

const pick = (obj={}, id) => !!obj?.[id];
const tk = {
  strategy: (objectiveId) => `new:strategy:${objectiveId}`,
  goal:     (strategyId)  => `new:goal:${strategyId}`,
  resource: (strategyId)  => `new:resource:${strategyId}`,
  resp:     (strategyId)  => `new:responsible:${strategyId}`,
};

export const usePlanFlags = (objectiveId) => {
  const s = useSelector((st) => st.improvementPlan);
  const O = s.objectives, E = s.estrategias, M = s.metas, R = s.recursos, P = s.responsables;

  return {
    // Objetivo actual
    obj: {
      saving:     pick(O.savingById, objectiveId),
      deleting:   pick(O.deletingById, objectiveId),
      completing: pick(O.completingById, objectiveId),
    },
    // Keys temporales (para creates)
    temp: {
      strategySaving: pick(E.savingById, tk.strategy(objectiveId)),
      goalSaving:     (strategyId) => pick(M.savingById, tk.goal(strategyId)),
      resourceSaving: (strategyId) => pick(R.savingById, tk.resource(strategyId)),
      respSaving:     (strategyId) => pick(P.savingById, tk.resp(strategyId)),
    },
    // Helpers por-id (edits/deletes existentes)
    is: {
      strategy:   { saving: (id) => pick(E.savingById, id), deleting: (id) => pick(E.deletingById, id) },
      goal:       { saving: (id) => pick(M.savingById, id), deleting: (id) => pick(M.deletingById, id) },
      resource:   { saving: (id) => pick(R.savingById, id), deleting: (id) => pick(R.deletingById, id) },
      responsible:{ saving: (id) => pick(P.savingById, id), deleting: (id) => pick(P.deletingById, id) },
    },
  };
};
